import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { S as StyledBasePagination } from './Pagination.styles-BbneMnHH.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const BasePagination = ({
  children,
  id,
  taktId,
  taktValue,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('pagination')
}, /*#__PURE__*/React__default.createElement(StyledBasePagination, _extends({}, restProps, {
  id: id
}), children));

export { BasePagination as B };
//# sourceMappingURL=BasePagination-B1_Hb1_t.js.map
